import type {FC, MouseEventHandler} from 'react';
import {Button} from '~library/atoms/Button';
import {Typography} from '~library/atoms/Typography';
import {ErrorCircleIcon} from '~library/svg/v2/ErrorCircleIcon';
import {XIcon} from '~library/svg/v2/XIcon';

import {error} from '~libSass/v2/_exports.sass';
import './DesignErrorAlert.sass';

interface DesignErrorAlertProps {
  message: string;
  onClose: MouseEventHandler<HTMLButtonElement>;
}

export const DesignErrorAlert: FC<DesignErrorAlertProps> = ({message, onClose}) => {
  return (
    <div className="design-error-alert">
      <ErrorCircleIcon color={error} ratio={0.5} />
      <Typography variant="paragraph3">{message}</Typography>
      <Button data-qa-id="dismiss-design-error" variant="unstyled-button" onClick={onClose}>
        <XIcon ratio={0.5} />
      </Button>
    </div>
  );
};
